import React from "react"
import { useNavigate } from "react-router-dom"
import styled from "styled-components"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faEnvelope, faQuestionCircle } from "@fortawesome/free-solid-svg-icons"

// --- Styled Components ---
const FooterContainer = styled.footer`
  width: 100%;
  background-color: #1e293b;
  color: white;
  padding: 2rem;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-around;
  gap: 2rem;
`

const CampusInfo = styled.div`
  flex: 1 1 300px;
  h3 {
    margin-bottom: 0.5rem;
    font-size: 1.2rem;
    color: #38bdf8;
  }
  p {
    font-size: 0.9rem;
    margin: 0.2rem 0;
  }
  iframe, div {
    margin-top: 0.5rem;
    width: 100%;
    height: 200px;
    border: none;
  }
`

const SocialLinks = styled.div`
  flex: 1 1 300px;
  .icons {
    display: flex;
    gap: 1rem;
    margin: 0.5rem 0;
    a img {
      height: 30px;
    }
  }
  .buttons {
    display: flex;
    flex-wrap: wrap;
    gap: 0.5rem;
    margin: 1rem 0;
  }
`

const VisitorCounter = styled.div`
  margin-top: 1rem;
  font-size: 1.2rem;
  font-weight: bold;
  color: #facc15;
  h3 {
    font-size: 1rem;
    font-weight: bold;
    color: #38bdf8;
    margin-bottom: 0.3rem;
  }
`

const Button = styled.button`
  background-color: #3b82f6;
  color: white;
  border: none;
  padding: 0.4rem 0.8rem;
  border-radius: 6px;
  cursor: pointer;
  font-size: 0.85rem;
  transition: background 0.2s ease;
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
  &:hover {
    background-color: #2563eb;
  }
`

const LogoSection = styled.div`
  flex: 1 1 300px;
  display: flex;
  align-items: center;
  gap: 0.5rem;
  font-size: 1.1rem;
  font-weight: bold;
  color: white;
  img {
    height: 50px;
    width: auto;
  }
`

// --- Footer 元件 ---
const Footer = ({ information, imageFileData = [] }) => {
    const navigate = useNavigate()

    const handleContactUs = () => {
        navigate("/officialweb/frontend/appointment")
    }

    const handleReportIssue = () => {
        navigate("/officialweb/frontend/question_and_answer")
    }

    const renderLogoImage = () => {
        const logo = imageFileData?.find((ele) => ele?.title === "頁尾Logo")
        const logoFiles = logo?.classify_structure_type_file_data || []
        if (logoFiles.length > 0) {
            return logoFiles.map((file) => (
                <img key={file.file_id} src={file?.file_url} alt="Footer Logo" />
            ))
        } else {
            const nameData = information?.name_language_data?.find(
                (ele) => ele.language_culture_code === "zh-tw"
            )
            return nameData?.language_culture_value || "Logo"
        }
    }

    return (
        <FooterContainer>
            <SocialLinks>
                <VisitorCounter>
                    <h3>網站瀏覽人次</h3>
                    <p>{information?.view_count}</p>
                </VisitorCounter>
                <h3>聯繫我們</h3>
                <div className="icons">
                    {(information?.information_community_data || []).map((item, index) => (
                        <a key={index} href={item.link} target="_blank" rel="noreferrer">
                            <img src={item.icon} alt="icon" />
                        </a>
                    ))}
                </div>
                <div className="buttons">
                    <Button onClick={handleContactUs}>
                        <FontAwesomeIcon icon={faEnvelope} /> 聯絡我們
                    </Button>
                    <Button onClick={handleReportIssue}>
                        <FontAwesomeIcon icon={faQuestionCircle} /> 常見問題
                    </Button>
                </div>

            </SocialLinks>
            <CampusInfo>
                <h3>介壽校區</h3>
                <p><strong>地址：</strong>{information?.address}</p>
                <p><strong>電話：</strong>{information?.phone}</p>
                <p><strong>電子郵件：</strong>{information?.email}</p>
                <div
                    dangerouslySetInnerHTML={{
                        __html: information?.google_map_iframe?.replace(
                            `width="600" height="450"`,
                            `width="100%" height="100%"`
                        ),
                    }}
                />
            </CampusInfo>

            <CampusInfo>
                <h3>巨輪校區</h3>
                <p><strong>地址：</strong>高雄市岡山區巨輪路1號</p>
                <p><strong>電話：</strong>07-6267542</p>
                <p><strong>電子郵件：</strong>{information?.email}</p>
                <iframe
                    src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3678.1082379444497!2d120.27990299999999!3d22.7984529!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x346e0c2167cae301%3A0xb92d99b38aee674d!2z56m66LuN6Iiq56m65oqA6KGT5a246Zmi5beo6Lyq5qCh5Y2A!5e0!3m2!1szh-TW!2stw!4v1735274491311!5m2!1szh-TW!2stw"
                    allowFullScreen=""
                    loading="lazy"
                ></iframe>
            </CampusInfo>
        </FooterContainer>
    )
}

export default Footer
